import { useEffect, useState } from 'react';
import { CircularProgress } from '@mui/material';
import QuillComponent from '../../../components/Form/QuillComponent';
import ModalComponent from '../../../components/ModalComponent';
import api from '../../../services/api';
import './NotificationStyle.css';

const Index = () => {
  const [isSaving, setIsSaving] = useState(false);
  const [text, setText] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    const awaitApi = async () => {
      await api.get('v1/home')
        .then((response) => {
          const { data } = response.data;
          if (data) {
            setText(data);
          }
        });
    };

    awaitApi().finally(() => {
      setIsLoading(false);
    });
  }, []);

  const handleSave = async () => {
    setIsSaving(false);
    setIsLoading(true);
    try {
      await api.post('v1/save-notification', { text });
      const response = await api.get('v1/home');
      const { data } = response.data;
      if (data) {
        setText(data);
      }
    } catch (error) {
      console.error('Error saving or loading data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (

    <div className="main">
      <main className="content p-3">
        <p>※管理画面のホームに表示するお知らせを記載します。</p>
        <div>
          {isLoading ? (
            <CircularProgress
              size={15}
              sx={{
                display: 'block',
                margin: '0 auto',
              }}
            />
          ) : (
            <QuillComponent
              text={text}
              updateHandler={setText}
            />
          )}
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '25px',
          }}
        >
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => setIsSaving(true)}
          >
            保存する
          </button>
        </div>
      </main>
      <footer className="footer d-none">
        <div className="container-fluid">
          <div className="row text-muted">
            <div className="col-6 text-start">
              &copy; 2023 BUILD-SELF
            </div>
            <div className="col-6 text-end">
              <div className="d-none d-sm-block">ver 1.0.0</div>
            </div>
          </div>
        </div>
      </footer>
      <a className="scroll-to-top rounded"><i className="fa-solid fa-angle-up" /></a>

      <ModalComponent
        title="お知らせ設定"
        confirmButtonText="保存する"
        onConfirm={handleSave}
        show={isSaving}
        closeModal={() => setIsSaving(false)}
        centered
        scrollable
        backdropClassName="z-index-3000"
        style={{ zIndex: 3001 }}
        body={
          <>保存しますか？</>
        }
      />
    </div>
  );
};

export default Index;
